var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.tabPermissions)?_c('div',{staticClass:"flex navigator"},_vm._l((_vm.tabPermissions),function(item,index){return _c('router-link',{key:index,attrs:{"to":item.u ? item.u : '/'}},[_c('div',{staticClass:"navigator-item",class:_vm.$route.path == item.u ? 'activeTab' : ''},[_vm._v(_vm._s(item.n))])])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }